import { render, staticRenderFns } from "./RankingViews.vue?vue&type=template&id=91be89ee&scoped=true&lang=pug&"
import script from "./RankingViews.vue?vue&type=script&lang=ts&"
export * from "./RankingViews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91be89ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91be89ee')) {
      api.createRecord('91be89ee', component.options)
    } else {
      api.reload('91be89ee', component.options)
    }
    module.hot.accept("./RankingViews.vue?vue&type=template&id=91be89ee&scoped=true&lang=pug&", function () {
      api.rerender('91be89ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/RankingViews.vue"
export default component.exports